export interface IMaturityRules {
  MaturityRuleID?: string// 1222
  MaturityMonthYearFormat?: number// 1303
  MaturityMonthYearIncrementUnits?: number// 1302
  StartMaturityMonthYear?: string// 1241
  EndMaturityMonthYear?: string// 1226
  MaturityMonthYearIncrement?: number// 1229
}
